import { render } from "./FlightCrewReportItem.vue?vue&type=template&id=2d8b4cb4"
import script from "./FlightCrewReportItem.vue?vue&type=script&lang=js"
export * from "./FlightCrewReportItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__